export enum TerminationAction {
    None,
    DisplayMessage,
    RedirectToUrl,
}
